const ROUTES = {
  LOGOUT: "/logout",
  SHIKSHALOKAM_HOME_PAGE: "/home",
  SHIKSHALOKAM_VOICE_CHAT_LOGIN: "/login",
  SHIKSHALOKAM_GUEST_PAGE: "/flow",
  SHIKSHALOKAM_VOICE_CHAT: "/voice-chat",
  SHIKSHALOKAM_GUEST_VOICE_CHAT: "/guest-chat",
  TERMS_AND_CONDITIONS: "/tnc",
  EXIT_ROUTE: "/exit",
  SSO_FLOW: "/sso",
};

export default ROUTES;